import script from "./CertificationResultCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertificationResultCard.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/search-page/search-page-result-card.css?vue&type=style&index=0&id=78ff7184&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78ff7184"]])

export default __exports__